<template>
  <div style="padding: 10px; background: #F1F2F5">
    <!-- tabs 栏 -->
    <div style="background-color: #FFFFFF;padding: 20px;display: flex;justify-content: space-between">
      <div class="head_box" style="flex-wrap: wrap;">
        <!--        <div class="head_box_item">素材标题：-->
        <!--          <el-input v-model="query.title" placeholder="搜索标题" style="width: 250px" />-->
        <!--        </div>-->
        <!--        <div class="head_box_item">书籍名称：-->
        <!--          <el-input v-model="query.book_name" placeholder="搜索标题" style="width: 250px" />-->
        <!--        </div>-->
        <el-input v-model="query.body" placeholder="请输入内容" class="input-with-select" style="width: 350px;margin-right: 5px">
          <el-select slot="prepend" v-model="query.head" placeholder="请选择" style="width: 120px">
            <el-option label="书籍名称" value="book_name" />
            <el-option label="素材标题" value="title" />
            <el-option label="平台名称" value="platform" />
          </el-select>
        </el-input>
        <div class="head_box_item">
          时间：
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="datePickerChange"
          />
        </div>
        <div class="head_box_item">
          <!-- @change="handleChange" -->
          投放类型
          <el-select v-model="query.post_type" placeholder="请选择投放类型">
            <el-option label="全部" :value="0" />
            <el-option label="IAA模式" :value="1" />
            <el-option label="IAP模式" :value="2" />
          </el-select>
        </div>
        <div class="head_box_item">
          点赞数
          <el-select v-model="query.like_count" style="width: 150px;margin: 10px">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="head_box_item">
          评论数
          <el-select v-model="query.comment_count" style="width: 150px;margin: 10px">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="head_box_item">
          分享数
          <el-select v-model="query.share_count" style="width: 150px;margin: 10px">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="head_box_item">
          收藏数
          <el-select v-model="query.favorite_count" style="width: 150px;margin: 10px">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="head_box_item">
          热度值
          <el-select v-model="query.heat" style="width: 150px;margin: 10px">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
      </div>
      <div class="head_box">
        <el-button type="info" size="mini" icon="el-icon-refresh" @click="refush">重置</el-button>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="list">搜索</el-button>
        <el-button type="success" size="mini" icon="el-icon-download" @click="exceOut">导出</el-button>
      </div>
    </div>

    <div class="line" />
    <div class="sticky-header">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            :checked="isChecked"
            @change="handleToggleAll"
          >
            全选
          </el-checkbox>
          <el-tag
            style="margin-left: 5px"
            closable
            @close="handleToggleAll(false)"
          >
            已选{{ selectedItems.length }}
          </el-tag>
        </div>
        <el-button
          type="success"
          icon="el-icon-download"
          :disabled="!selectedItems.length"
          @click="downloadMaterial"
        >下载</el-button>
      </div>
    </div>
    <!-- 数据展示区域 -->
    <div style="display: flex;flex-wrap: wrap">
      <div
        v-for="(item, index) in table_data"
        :key="index"
        style="width: 438px;height: 312px;margin: 10px 8px;background-color: #FFFFFF;border-radius: 5px;border: 1px solid rgb(240, 242, 245);"
      >
        <div
          style="height: 48px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer;"
          @click.stop="selectTab(item)"
        >
          <div style="display: flex;align-items: center;">
            <div
              style="color: rgb(29, 33, 41); font-size: 16px;width: 310px;;
            overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
            >
              {{ item.book_name }}
            </div>
            <div v-if="item.platform" style="margin-left: 25px;">
              <el-tag>{{ item.platform }}</el-tag>
            </div>
          </div>

          <div style="display: flex;align-items: center;">
            <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px">
              <div style="margin-bottom:7px;font-weight:600;font-size:16px">{{ item.miniseries_name }}</div>
            </div>
          </div>
          <div style="text-align: end">
            <el-checkbox
              style="pointer-events: none"
              :value="selectedItems.includes(item)"
              @click.native.stop
            />
            <div style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.publisher_name }}</div>
          </div>
        </div>

        <div
          style="cursor: pointer;position: relative;"
          @click="itemInfo(item)"
        >
          <!--            :src="item.pic_list[0]"-->
          <!--            :alt="item.pic_list[0]"-->
          <el-image
            :src="item.cover_url"
            referrerpolicy="no-referrer"
            style="width: 436px;height: 180px"
            fit="cover"
          />
          <div style="position: absolute;bottom:0px;left:0px;display: flex;background-color: rgba(0, 0, 0, 0.3);padding: 10px 30px;width: 100%;justify-content: space-between;">
            <div>
              <img
                style="width:20px;height:20px;margin-right:5px"
                src="@/assets/images/adx/favorite.png"
                alt=""
                srcset=""
              >
              <span style="color:white">{{ item.favorite_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/like.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.like_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/comment.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.comment_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/forward.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.share_count }}</span>
            </div>
          </div>
        </div>
        <div
          style="height: 154px;padding: 20px 0;cursor: pointer"
          @click="itemInfo(item)"
        >
          <div style="height: 30px; font-size: 16px; line-height: 25px; padding: 0 20px;">
            <div
              style="color: #1D2129;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
              v-html="item.title"
            />
          </div>
        </div>
      </div>
    </div>

    <pagination-right
      :total="total"
      :page-sizes="[30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :visible.sync="info_visible"
      :destroy-on-close="true"
      width="1000px"
      title="素材详情"
    >
      <Info ref="matinfo" />
    </el-dialog>
  </div>
</template>

<script>
import { exportNovel, NovelInfoList } from '@/api/report/dxj'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Info from '@/views/dxj/Materials/components/info.vue'
export default {
  components: { Info, PaginationRight },
  data() {
    const today = new Date()
    const format = (d) => {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
    const todayStr = format(today)
    return {
      todayStr,
      query: {
        page: 1,
        page_size: 30,
        // playlet_id: null,
        like_count: null,
        comment_count: null,
        share_count: null,
        favorite_count: null,
        heat: null,
        // title: null,
        // book_name: null,
        start_time: todayStr,
        end_time: todayStr,
        head: 'book_name',
        body: null,
        // iaa: null,
        // iap: null,
        post_type: 0
      },
      total: 0,
      table_data: [],
      keyword: null,
      selectedItems: [],
      slot_option: [
        { label: '点赞数', value: '1' },
        { label: '评论数', value: '2' },
        { label: '分享数', value: '3' },
        { label: '收藏数', value: '4' },
        { label: '热度值', value: '5' }
      ],
      slot_value: null,
      date: [todayStr, todayStr],
      option: [
        { label: '最少', value: 1 },
        { label: '最多', value: 2 }
      ],
      info_visible: false,
      type: 'all'
    }
  },
  computed: {
    isChecked() {
      const list = this.material_data?.list || []
      return list.length > 0 && this.selectedItems.length === list.length
    },
    isIndeterminate() {
      const list = this.material_data?.list || []
      return this.selectedItems.length > 0 && this.selectedItems.length < list.length
    }
  },
  created() {
    console.log(this.query)
    // 初始化查询参数
    this.list()
  },
  methods: {
    list() {
      const params = {
        ...this.query,
        [this.query.head]: this.query.body // 动态键名，如 { book_name: "xxx" }
      }
      NovelInfoList(params).then(res => {
        console.log(res)
        this.table_data = res.data.list
        this.total = res.data.total
      })
    },
    refush() {
      this.query = {
        page: 1,
        page_size: 30,
        playlet_id: null,
        like_count: null,
        comment_count: null,
        share_count: null,
        favorite_count: null,
        heat: null,
        /* book_name: null,
        title: null,*/
        start_time: this.todayStr,
        end_time: this.todayStr,
        head: 'book_name',
        body: null,
        // iaa: null,
        // iap: null
        post_type: 0
      }
      this.type = 'all'
      this.date = [this.todayStr, this.todayStr]
      this.list()
    },
    addStrategy() {

    },
    linkToInfo(val) {
      console.log(val)
    },
    search() {
      this.list()
    },
    selectTab(val) {
      const index = this.selectedItems.indexOf(val)
      if (index === -1) {
        this.selectedItems.push(val)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    fetchPageSize(data) {
      this.query.page_size = data
      this.list()
    },
    fetchCurrentPage(data) {
      this.query.page = data
      this.list()
    },
    handleToggleAll(val) {
      if (val) {
        this.selectedItems = this.generateAllItems()
      } else {
        this.selectedItems = []
      }
    },
    generateAllItems() {
      // eslint-disable-next-line eqeqeq
      return this.table_data.filter(item => item.upload_status != 1)
    },
    async downloadMaterial() {
      var videoUrls = this.selectedItems.map(item => item.video_url)
      for (let i = 0; i < videoUrls.length; i++) {
        const url = videoUrls[i]
        try {
          const response = await fetch(url)
          const blob = await response.blob()
          const blobUrl = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = blobUrl
          a.download = `video_${i + 1}.mp4`
          a.click()

          setTimeout(() => {
            URL.revokeObjectURL(blobUrl) // 释放内存
          }, 100)
        } catch (error) {
          console.error(`下载失败: ${url}`, error)
        }
      }
    },
    exceOut() {
      const params = {
        ...this.query,
        [this.query.head]: this.query.body // 动态键名，如 { book_name: "xxx" }
      }
      exportNovel(params).then(res => {
        window.open(res.data.url)
      })
    },
    datePickerChange() {
      console.log(this.date.length)
      if (this.date.length === 2) {
        this.query.start_time = this.date[0]
        this.query.end_time = this.date[1]
      }
    },
    itemInfo(val) {
      console.log(val.material_id)
      this.info_visible = true
      this.$nextTick(() => {
        this.$refs.matinfo.send(val, 1)
      })
    },
    handleChange(val) {
      if (val === 'all') {
        this.query.iaa = null
        this.query.iap = null
      } else if (val === 'iaa') {
        this.query.iaa = 2
        this.query.iap = 0
      } else if (val === 'iap') {
        this.query.iaa = 0
        this.query.iap = 2
      }
    }
  }
}
</script>

<style scoped>

.line {
  height: 1px;
  background: #e5e6eb;
  margin-top: 1px;
}
.sticky-header {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  position: sticky;
  top: 0px;
  z-index: 999;
  border: 1px solid rgb(240, 242, 245);
}
.head_box {
  align-items: center;
  /* justify-content: center; */
  display: flex
}
.head_box_item {
  margin-right: 5px;
}
</style>
